import { Icon } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';
import { TouchableOpacity, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { LinkNoDecoration } from 'components/app-header/styled';
import { modalHeaderStyles } from 'components/card-modal-header';
import { Logo } from 'components/logo';
import { NAV_HEIGHT } from 'styles/constants/enums';
import { isIOS } from 'utils/environment';
import { routes } from 'utils/routing';

interface IWalmartHeader {
  authzCode?: string | string[] | null;
  disabled?: boolean;
}

export const WalmartHeader = ({ authzCode, disabled = false }: IWalmartHeader) => {
  const { top } = useSafeAreaInsets();
  const router = useRouter();

  if (disabled) {
    return null;
  }

  return (
    <View
      style={{
        ...modalHeaderStyles.headerContainer,
        // Safe area margin not needed for iOS
        marginTop: !isIOS ? top : 0,
        height: NAV_HEIGHT.MOBILE,
      }}
    >
      <View style={modalHeaderStyles.headerFlexStart}></View>
      <LinkNoDecoration onPress={() => router.replace(routes.base)}>
        <Logo />
      </LinkNoDecoration>
      <View style={modalHeaderStyles.headerFlexEnd}>
        <TouchableOpacity
          onPress={() => (router.canGoBack() ? router.back() : router.replace(routes.base))}
          testID="modal-back-button"
          hitSlop={15}
        >
          <Icon variant="cancel" />
        </TouchableOpacity>
      </View>
    </View>
  );
};
